import { MemoConfirmDialog } from '../ResolvableServiceUser/MemoConfirmDialog';
import type { SubmitHandler } from '../ResolvableServiceUser/types/submit-handler.type';

import type { ManualTotalFormValues } from './types/values.type';

interface Props {
  readonly description: string;
  readonly initialValue: ManualTotalFormValues['value'];
  readonly isDialogOpen: boolean;
  readonly onCloseDialog: () => void;
  readonly onSubmit: SubmitHandler<ManualTotalFormValues>;
  readonly submitLabel: string;
  readonly title: string;
}

export const ManualTotalDialogForm = ({
  description,
  initialValue,
  isDialogOpen,
  onCloseDialog,
  onSubmit,
  submitLabel,
  title,
}: Readonly<Props>) => (
  <MemoConfirmDialog<ManualTotalFormValues>
    description={description}
    id="manual-total"
    initialValues={{ value: initialValue }}
    isDialogOpen={isDialogOpen}
    onCloseDialog={onCloseDialog}
    onSubmit={onSubmit}
    submitLabel={submitLabel}
    title={title}
  />
);
